module.exports = __webpack_public_path__ + "static/matias-7081361a39b7aab1969496953ebeaf42.png";